import resume from "../assets/pdf/frontend_resume_ankit.pdf";
import MyProfileImage from "../assets/images/my_profile.jpeg";

export const headerData = {
  name: "Ankit Rajpoot",
  title: "Frontend Developer",
  desciption:
    "I'm a passionate Frontend Developer with a strong focus on building responsive, high-performance web applications. I love turning complex problems into simple, beautiful interfaces that enhance user experience.",
  image: MyProfileImage,
  resumePdf: resume,
};
